export const states = [
  { id: 1, name: "Andaman and Nicobar Islands", code: "AN" },
  { id: 2, name: "Andhra Pradesh", code: "AP" },
  { id: 3, name: "Arunachal Pradesh", code: "AR" },
  { id: 4, name: "Assam", code: "AS" },
  { id: 5, name: "Bihar", code: "BR" },
  { id: 6, name: "Chandigarh", code: "CH" },
  { id: 7, name: "Chhattisgarh", code: "CT" },
  { id: 8, name: "Dadra and Nagar Haveli and Daman and Diu", code: "DN" },
  { id: 9, name: "Delhi", code: "DL" },
  { id: 10, name: "Goa", code: "GA" },
  { id: 11, name: "Gujarat", code: "GJ" },
  { id: 12, name: "Haryana", code: "HR" },
  { id: 13, name: "Himachal Pradesh", code: "HP" },
  { id: 14, name: "Jammu and Kashmir", code: "JK" },
  { id: 15, name: "Jharkhand", code: "JH" },
  { id: 16, name: "Karnataka", code: "KA" },
  { id: 17, name: "Kerala", code: "KL" },
  { id: 18, name: "Ladakh", code: "LA" },
  { id: 19, name: "Lakshadweep", code: "LD" },
  { id: 20, name: "Madhya Pradesh", code: "MP" },
  { id: 21, name: "Maharashtra", code: "MH" },
  { id: 22, name: "Manipur", code: "MN" },
  { id: 23, name: "Meghalaya", code: "ML" },
  { id: 24, name: "Mizoram", code: "MZ" },
  { id: 25, name: "Nagaland", code: "NL" },
  { id: 26, name: "Odisha", code: "OR" },
  { id: 27, name: "Puducherry", code: "PY" },
  { id: 28, name: "Punjab", code: "PB" },
  { id: 29, name: "Rajasthan", code: "RJ" },
  { id: 30, name: "Sikkim", code: "SK" },
  { id: 31, name: "Tamil Nadu", code: "TN" },
  { id: 32, name: "Telangana", code: "TG" },
  { id: 33, name: "Tripura", code: "TR" },
  { id: 34, name: "Uttar Pradesh", code: "UP" },
  { id: 35, name: "Uttarakhand", code: "UT" },
  { id: 36, name: "West Bengal", code: "WB" },
];
